import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidationErrors, ValidatorFn } from '@angular/forms';
import { ChangeLogLoanItem } from '../models/ChangeLogLoanItem'
import { ChangeLogService } from '../changeLog.service'
import { ChangeLogDataRequestParams } from '../models/auctionRequest'
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { PaginationParams } from '../models/loanItem';
import {Table} from 'primeng/table';
import * as _ from 'lodash';
import { checkFieldsValidity } from '../../shared/index'

@Component({
  selector: 'app-change-log-details',
  templateUrl: './change-log-details.component.html',
  styleUrls: ['./change-log-details.component.scss']
})

export class ChangeLogDetailsComponent implements OnInit, OnChanges {

  @ViewChild('dt') table: Table;
  changeLogForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  disableChangeLogForm: boolean;
  selecletedLoans: any[];
  selectedUsers: any[];
  cols: any[];
  changeLogData: ChangeLogLoanItem[];
  loading: boolean;
  changedBySelectorDisabled = true;
  changedBySelectorFilter = false;
  loansSelectorDisabled = true;
  loansSelectorFilter = false;
  reqParms: ChangeLogDataRequestParams;
  records = 0;
  excelUrl: string;
  changedBy: any[];
  loans: any[];
  loadingSearchResult = false;
  formSubmitted = false;
  paginationParams: PaginationParams = { offset: 0, pageSize: 10, sortValue: 'SubmitDate', sortDir: 'D' };
  viewButtonLabel: string;
  rowcount:number = 10;
  showTable: boolean;

  constructor(private changelogService: ChangeLogService) { }

  ngOnInit() {
    this.disableChangeLogForm = false;
    this.loans = [{name: "Loading..", code: "Loading.."}];
    this.changedBy = [{name: "Loading..", code: "Loading.."}];
    this.viewButtonLabel = 'View';
    this.changeLogForm = new FormGroup({
      changedBy: new FormControl('', null),
      loanNumber: new FormControl('', null),
      toDate: new FormControl('', null),
      fromDate: new FormControl('', null)
    }, checkFieldsValidity(Validators.required));
    
    this.formControlValueChanged();

    this.cols = [
      { field: 'auctionUpdateHistoryID', header: 'AuctionUpdate History ID', showInHeader: false },
      { field: 'changeDate', header: 'Changed Date', showInHeader: true },
      { field: 'changedBy', header: 'Changed By', showInHeader: true },
      { field: 'loanNumber', header: 'Loan Number', showInHeader: true },
      { field: 'UpdateStatusValue', header:'Status' ,showInHeader:true},
      { field: 'initialReservePricePercentageOld', header: '% Of Initial Reserver Price Old', showInHeader: false },
      { field: 'initialReservePricePercentageNew', header: '% Of Initial Reserver Price New', showInHeader: false },
      { field: 'reservePriceOld', header: 'ReservePrice Old', showInHeader: false },
      { field: 'reservePriceNew', header: 'ReservePrice New', showInHeader: false },
      { field: 'reservePriceReductionPercentageOld', header: 'Reserve PriceReduction Percentage Old', showInHeader: false },
      { field: 'reservePriceReductionPercentageNew', header: 'Reserve PriceReduction Percentage New', showInHeader: false }
    ];

    this.changelogService.getChangeLogDataSelectors().subscribe(response => {
      if (response.loans.length > 0) {
        this.loansSelectorDisabled = false;
        this.loansSelectorFilter = true;
        this.loans = response.loans;
      } else {
        this.loans = [{name: "No Data", code: "No Data"}];
      }
      if (response.changedBy.length > 0) {
        this.changedBySelectorDisabled = false;
        this.changedBySelectorFilter = true;
        this.changedBy = response.changedBy;
      } else {
        this.changedBy = [{name: "No Data", code: "No Data"}];
      }
    });
    
  }

  getChangeLogData(): void {
    this.loadingSearchResult = true;
    this.changelogService.getChangeLogData(this.reqParms,this.paginationParams).subscribe(changeLogData => {
      this.records = (<any>changeLogData).meta.pagination.TotalRecords;
      this.changeLogData = changeLogData.data;
      this.excelUrl = (<any>_GlobalNS).routes.auction.changelog.buildExcel;
      this.reqParms.pageRecords = this.records;
      this.buildExcelUrl();
      this.viewButtonLabel = 'View';
      this.loadingSearchResult = false;
      this.showTable = true;
    });
  }

  ngOnChanges() {
    this.resetForm();
  }

  isPaginatorVisible(): boolean{
    return (this.changeLogData && this.changeLogData.length >0) ? true : false;
  }

  formControlValueChanged() {
    this.changeLogForm.get('fromDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.maxDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate > this.maxDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });

    this.changeLogForm.get('toDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.minDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate < this.minDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });
  }

  setDateRange(days: number): void {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - days);
    this.minDate = tempDate;
    this.maxDate = new Date();
  }

  resetForm(): void {
    this.minDate = null;
    this.maxDate = null;
    this.selecletedLoans = [];
    this.selectedUsers = [];
    this.changeLogData = [];
    this.loadingSearchResult = false;
    this.showTable = false;
  }

  onSubmitChangeLogForm(): void {
    this.formSubmitted = true;
    this.paginationParams = { offset: 0, pageSize: 10, sortValue: 'SubmitDate', sortDir: 'D' };
    this.viewButtonLabel = 'Viewing..';
    this.showTable = false;
    if(this.table != undefined)
    this.table.rows = this.rowcount;
    this.setChangeLogRequestParams();
    this.getChangeLogData();
  }

  buildExcelUrl() {
    let urlString = '&';
    Object.keys(this.reqParms).forEach(key => {
      let parmVal = this.reqParms[key].toString();
      if(parmVal.length){
        urlString = urlString + key + '=' + this.reqParms[key] + '&';
      }
    });
    this.excelUrl = this.excelUrl + urlString.slice(0, -1);
  }

  setChangeLogRequestParams(): void {
    this.reqParms = <ChangeLogDataRequestParams>{};
    this.reqParms.changedBy = this.formatParams(this.changeLogForm.value.changedBy);
    this.reqParms.loanNumber = this.formatParams(this.changeLogForm.value.loanNumber);
    this.reqParms.dateTo = this.changeLogForm.value.toDate == null ? '' : this.formatDate(this.changeLogForm.value.toDate);
    this.reqParms.dateFrom = this.changeLogForm.value.fromDate == null ? '' : this.formatDate(this.changeLogForm.value.fromDate);
    this.reqParms.sortDir = 'D';
    this.reqParms.sortValue = 'SubmitDate';
  }

  formatParams(res): string {
    const userList = [];
    if (res) {
      res.map(item => {
        userList.push(item.code);
      });
    }
    return userList.toString();
  }

  formatDate(dateObj: Date): string {
    let current_datetime = dateObj;
    let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate();
    return formatted_date;
  }

  onPage(event): void {
    this.paginationParams = {
      offset: (event.first !== undefined ? event.first : this.paginationParams.offset)
      , pageSize: (event.rows !== undefined ? event.rows : this.paginationParams.pageSize)
      , sortDir: (event.sortOrder === 1 || event.sortOrder === 'D') ? 'D' : 'Asc'
      , sortValue: event.sortField ? event.sortField : 'SubmitDate'
    };
    this.getChangeLogData();
  }

}
